import type { Difficulty } from "@hunch/core";

export interface CrowflightPlace {
  id: number;
  nameDe: string;
  nameEn: string;
  lat: number;
  lon: number;
}

export interface CrowflightRegionsResponse {
  continents: Array<{ continent: string; count: number }>;
  countries: Array<{ countryCode: string; name: { de: string; en: string }; count: number }>;
}

export interface CrowflightPoolSize {
  count: number;
  threshold: number;
  enough: boolean;
}

export interface CrowflightDuel {
  reference: CrowflightPlace;
  options: [CrowflightPlace, CrowflightPlace];
}

export interface CrowflightNewGame {
  pointsPerItem: number;
  r1: { reference: CrowflightPlace; places: CrowflightPlace[] };
  r2: { places: CrowflightPlace[] };
  /** Each duel has its own reference city — not one shared across all 5. */
  r3: { duels: CrowflightDuel[] };
  r4: { reference: CrowflightPlace; place: CrowflightPlace };
}

async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(path, { credentials: "omit" });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error ?? `Request failed (${res.status})`);
  }
  return (await res.json()) as T;
}

export function fetchCrowflightRegions(difficulty: Difficulty): Promise<CrowflightRegionsResponse> {
  return getJson(`/api/public/crowflight/regions?difficulty=${difficulty}`);
}

export function fetchCrowflightPoolSize(region: string, difficulty: Difficulty): Promise<CrowflightPoolSize> {
  const params = new URLSearchParams({ region, difficulty });
  return getJson(`/api/public/crowflight/pool-size?${params.toString()}`);
}

export function fetchCrowflightNewGame(region: string, difficulty: Difficulty): Promise<CrowflightNewGame> {
  const params = new URLSearchParams({ region, difficulty });
  return getJson(`/api/public/crowflight/new-game?${params.toString()}`);
}
